import { hasSettled, retryTransient } from 'utils/api/fanOutQueries';
import { DATA_SOURCES } from '@/config/constants';
import { apiDataSource } from 'utils/entities';
import { fetchEntityPresence } from 'utils/api/entities.api';
import { useQueries } from 'react-query';

/** The order hints are offered in, which is the order the tabs are in. */
const SOURCE_ORDER = [
    DATA_SOURCES.POPULARITY,
    DATA_SOURCES.GOOGLE,
    DATA_SOURCES.TIKTOK,
    DATA_SOURCES.INSTAGRAM,
];

/**
 * Which markets each data source has data for, for one entity.
 *
 * Deliberately not folded into `useEntityAcrossSources`: that hook resolves the
 * page title on every page and has no reason to pay for a data-store scan.
 */
const usePresenceAcrossSources = ({
    id,
    entityType = 'categories',
    enabled = true,
}) => {
    const results = useQueries(
        SOURCE_ORDER.map((source) => ({
            queryKey: [
                'entity-presence-across-sources',
                { id, entityType, source },
            ],
            queryFn: () =>
                fetchEntityPresence({
                    dataSource: apiDataSource(source),
                    entityType,
                    ids: [id],
                }),
            enabled: enabled && !!id,
            staleTime: Infinity,
            retry: retryTransient,
        })),
    );

    const isLoading = !results.every(hasSettled);

    // Only a source that answered is recorded: "we could not ask" must not
    // read as "it has nothing".
    const presence = {};
    if (!isLoading)
        results.forEach(({ data, isSuccess }, index) => {
            if (isSuccess) presence[SOURCE_ORDER[index]] = data?.[id] || [];
        });

    return { isLoading, presence };
};

export { SOURCE_ORDER };
export default usePresenceAcrossSources;
